import { apiClient } from "lib/apiClient";

export const activateEmail = async (token: string) => {
  const response = await apiClient.put(`/verification/${token}`);

  return response.data;
};
